import React from "react";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";

Bugsnag.start({
  apiKey: process.env.NEXT_PUBLIC_BUGSNAG_API_KEY,
  appVersion: process.env.NEXT_PUBLIC_HEROKU_RELEASE_VERSION,
  plugins: [new BugsnagPluginReact(React)].filter(Boolean),
  onError: (event) => !event?.originalError?.message?.includes("404"),
  enabledReleaseStages: ["production", "staging"],
});

export default Bugsnag;
